<template>
  <thead>
    <tr>
      <th class="bordazIndex" style="z-index: 3 !important">
        <span class="text-right w-100 d-block pr-2">
          Vidas
        </span>
      </th>
      <template v-for="(operadora, indexo) in cenarios[0].operadoras">
        <b-th
          class="pb-0"
          :colspan="parsePlanos(operadora.grupos).length"
          :key="`novo-grupo-0-${indexo}`">
          <b-img
            center
            :src="operadora.logotipoavo"
            style="width: 80px"
            :alt="operadora.nome"
            :title="operadora.nome"
          />
          <div
            class="cor-logo"
            :style="`
              height: 3px;
              background-color: ${operadora.cor ? '#'+operadora.cor.replace('#', '') : 'grey'};
              margin: 0 auto;
              border-radius: 25px;
            `"
          ></div>
        </b-th>
      </template>
    </tr>
  </thead>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters("cenario", {
      cenarios: "getCenarios"
    }),
  },
  methods: {
    parsePlanos(grupos) {
      return grupos.reduce(function(prev, curr) {
        return [...prev, ...curr.planos];
      }, [])
    }
  }
}
</script>

<style>

</style>
